import {loadable} from 'router/routes';

const AccountVerification = loadable(() => import('./AccountVerification'));

export default AccountVerification;
